"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicDataClient = void 0;
const BaseClient_1 = require("../BaseClient");
class PublicDataClient extends BaseClient_1.BaseClient {
    constructor(appName, baseUrl) {
        super(baseUrl);
        this.appName = appName;
        this.baseUrl = baseUrl;
    }
    publicDataGetAppManifest() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: `/public-data/${this.appName}/app-manifest`,
            });
            return response.data;
        });
    }
    publicDataGetObject(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: `/public-data/${this.appName}/${key}`,
            });
            return response.data;
        });
    }
    publicDataGetRaw(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                responseType: 'text',
                url: `/public-data/${this.appName}/${key}`,
            });
            return response.data;
        });
    }
}
exports.PublicDataClient = PublicDataClient;
